import { useEffect, useRef } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const PING_INTERVAL = 4 * 60 * 1000; // 4 minuti

export default function KeepAlive() {
  const intervalRef = useRef(null);

  useEffect(() => {
    const ping = async () => {
      try {
        await fetch(`${API_URL}/api/health`, { method: 'GET' });
      } catch {
        // silenzioso — il ping è best-effort
      }
    };

    // Primo ping immediato
    ping();
    intervalRef.current = setInterval(ping, PING_INTERVAL);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return null;
}
